import { FeatureFlags } from '@fabric-ui/components';
import { createFileRoute } from '@tanstack/react-router';
import { PAGE_PATHS, Permission } from '../../../../../types';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/settings/customer-details/')({
  beforeLoad: ({ context, preload }) => {
    const isAllowed =
      !!context.featureFlags[FeatureFlags.CustomerManagementScreen] &&
      !!context.userPermissions.hasAllowedPermission({ path: PAGE_PATHS.CUSTOMER_DETAILS, permission: Permission.READ });
    context.validatePermissions({ isAllowed, preload });
  },
});
